import React, {
  useEffect,
  useRef,
  useState,
  useContext,
  useCallback,
} from "react";
import classNames from "classnames/bind";
import streamingClient from "../../../services/streamingClient";
import Header from "./Header";
import StreamCam from "./StreamCam";
import { CameraContext } from "../LiveCamera";
import styles from "./Camera.module.css";
import ModalSetting from "../../Administration/Camera/ModalSetting";
import ModalInfo from "../../Administration/Camera/ModalInfo";
import axiosClient from "../../../services/axiosClient";
import SearchFail from "../../Location/SearchFaild/SearchFail";
import { cameraManagement } from "../../../services/api/cameraManagementApi";
import { useStoreContext } from "../../../hooks/useStoreContext";
import RenameCamera from "./RenameCamera/RenameCamera";
import { Toast } from "../../../components";
import { changePathStream } from "../../../utils";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles);
const Camera = ({ cameraSelect }) => {
  const {
    setIsLoadingCamera,
    refreshPath,
    screen,
    isFullScreen,
    setIsFullScreen,
    setCurrentPage,
    showTaskbar,
    isLoadingCamera,
    isGroup,
    groupCode,
    oneThread,
    isSearchCam,
    setIsSearchCam,
    setRefreshPath,
    filterStatus,
    setFilterStatus,
    setIsOneCameraFullScreen,
    isOneCameraFullScreen
  } = useContext(CameraContext);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [infoCamera, setInfoCamera] = useState([]);
  const [isModalInfo, setIsModalInfo] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isRename, setIsRename] = useState(false);
  const [streaming, setStreaming] = useState([]);
  const [nameCamera, setNameCamera] = useState("");
  const [pathSse, setPathSse] = useState([]);
  const [dataStore, dispatch] = useStoreContext();
  const { t } = useTranslation();
  const ref = useRef();
  const updateStreaming = useCallback((data) => {
    setStreaming(data);
  }, []);
  console.log("isOneCameraFullScreen", isOneCameraFullScreen);

  const escFunction = (event) => {
    console.log("isOneCameraFullScreen", event.keyCode);

    if (event.keyCode === 27) {
      event.preventDefault();
      setIsFullScreen(false);
      setIsOneCameraFullScreen(false);
    } else if (event.keyCode === 122 || event.keyCode === 115) {
      event.preventDefault();
      setIsFullScreen(!isFullScreen);
    }
  };
  const handleSetFilter = (data, status) => {
    if (!isLoadingCamera) {
      setFilterStatus({
        ...filterStatus,
        [status]: data,
      });
      sessionStorage.setItem(
        "status",
        JSON.stringify({
          ...filterStatus,
          [status]: data,
        })
      );
      setCurrentPage(1);
    }
  };
  React.useEffect(() => {
    if (ref.current) {
      if (document.fullscreenEnabled) {
        if (isFullScreen) {
          ref.current.click();
          ref.current.requestFullscreen();
        }
        if (!isFullScreen && document.fullscreenElement) {
          document.exitFullscreen();
        }
      }
    }
    const setScreen = (e) => {
      if (!document.fullscreenElement) {
        setIsFullScreen(false);
        setIsSearchCam(false);
        setIsOneCameraFullScreen(false);
      }
    };
    document.addEventListener("keydown", escFunction);
    document.addEventListener("fullscreenchange", setScreen);
    return () => {
      document.removeEventListener("keydown", escFunction);
      document.removeEventListener("fullscreenchange", setScreen);
    };
  }, [isFullScreen, isOneCameraFullScreen]);
  const reNameCamera = async () => {
    try {
      const res = await cameraManagement.reName(
        { camera_name: nameCamera.name },
        nameCamera.code
      );
      if (res.result) {
        Toast.open(t("stream.renameCameraSuccess"), "success");
      }
      setIsRename(false);
      setRefreshPath(!refreshPath);
    } catch (e) {
      Toast.open(t("stream.renameCameraError"), "danger");
    }
  };
  React.useEffect(() => {
    const getListPathStreaming = async () => {
      if (cameraSelect && cameraSelect.length > 0) {
        try {
          const test = cameraSelect?.map((item) => {
            return { camera_code: item.camera_code };
          });
          if (test.length > 0) {
            // await updateStatus();
            const res = await streamingClient.post(
              "/streamManagement/post-list-path-streaming/",
              oneThread && isGroup && !isSearchCam
                ? {
                  list_group: {
                    data: [
                      {
                        group_code: groupCode,
                      },
                    ],
                  },
                }
                : {
                  list_camera: {
                    data: test,
                  },
                }
            );
            const listStream = res?.stream.map((item) => {
              if (item.code) {
                return {
                  url: `${process.env.REACT_APP_BASE_URL}livestream${item.data.length > 1
                    ? item?.data[1].PATH
                    : item?.data[0].PATH
                    }`,
                  url2: `${process.env.REACT_APP_BASE_URL}livestream${item?.data[0].PATH}`,
                  isOption: false,
                  name: item?.name,
                  is_AI: item.is_AI,
                  image: `${process.env.REACT_APP_BASE_URL}livestream/${item?.data[0]?.PATH?.split("/")[1]
                    }/image.jpg`,
                  status:
                    item?.status_active === 3
                      ? "Off"
                      : (item?.status_active === 2) |
                        (item?.status_active === 1)
                        ? "Weak"
                        : "On",
                  code: item.code,
                  time_start: item.time_start,
                  time_end: item.time_end,
                  is_VOICE: item?.is_VOICE,
                  list_ai_service:
                    item?.list_ai_service?.filter((ai) => ai?.status === 1) ||
                    [],
                  type_camera: item?.data[0]?.CAMERA_TYPE_CODE,
                  temperature: "30.00",
                  list_ai_service_registed:
                    item?.list_ai_service_registed || [],
                  rtc:
                    item.data.length > 1
                      ? item?.data[1].WEBRTC
                      : item?.data[0].WEBRTC,
                  protocol:
                    item.data.length > 1
                      ? item?.data[1].STREAM_PROTOCOL
                      : item?.data[0].STREAM_PROTOCOL,
                  camera_recorder_code: item?.data[0]?.CAMERA_RECORDER_CODE,
                  rtsp_restream: item?.data[0]?.RTSP_CHINH
                };
              }
              return null;
            });
            setStreaming((prevStreaming) => {
              const isDiff = JSON.stringify(prevStreaming) !== JSON.stringify(listStream);
              return isDiff ? listStream : prevStreaming;
            });
            setTotal(listStream.length);
            setIsLoadingCamera(false);
          } else {
            setStreaming([]);
            setIsLoadingCamera(false);
          }
        } catch (error) {
          setIsLoadingCamera(false);
          setStreaming([]);
          // throw new Error("We can't get path streaming");
        }
      }
      setIsLoadingCamera(false);
    };
    const x = setInterval(() => {
      getListPathStreaming();
      // // console.log('run');
    }, 2 * 60000);
    getListPathStreaming();
    return () => {
      clearInterval(x);
    };
  }, [
    cameraSelect,
    dataStore.toggleNotification,
    refreshPath,
    groupCode,
    isSearchCam,
  ]);
  React.useEffect(() => {
    const eventSource = new EventSource(
      `${process.env.REACT_APP_SSE_LIVE
      }get-repath-stream/?token=${sessionStorage.getItem("token")}`
    );
    eventSource.onmessage = (event) => {
      setPathSse(event.data);
    };
    eventSource.onerror = (error) => {
      eventSource.close();
    };
    return () => {
      eventSource.close();
    };
  }, []);
  useEffect(() => {
    if (streaming.length > 0) {
      const path = changePathStream(streaming, pathSse);
      setStreaming(path);
    }
  }, [pathSse]);
  useEffect(() => {
    setPage(total / screen.total < 1 ? 1 : Math.ceil(total / screen.total));
  }, [screen, total]);

  const getDataCamera = async (code) => {
    setIsLoad(true);
    const res = await axiosClient.get(
      `cameraManagement/get-camera-info-by-code/?camera_code=${code}`
    );
    setInfoCamera(res);
    setIsLoad(false);
  };

  const handleGetShowInfoCamera = (code) => {
    setIsModalInfo(!isModalInfo);
    getDataCamera(code);
  };

  const handleClose = () => {
    setIsModalInfo(!isModalInfo);
  };

  const handleCloseSetting = () => {
    setIsSetting(!isSetting);
    // làm mới số icon hiện trên header
    setRefreshPath(!refreshPath);
  };
  const handleGetShowSetting = async (code) => {
    await getDataCamera(code);
    setIsSetting(!isSetting);
  };
  const handleCloseRename = () => {
    setIsRename(!isRename);
  };
  useEffect(() => {
    if (sessionStorage.getItem("status")) {
      setFilterStatus(JSON.parse(sessionStorage.getItem("status")));
    }
  }, []);
  return (
    <div
      ref={ref}
      className={cx("container")}
      style={isFullScreen ? { padding: "0" } : { paddingTop: "0" }}
    >
      <Header filter={filterStatus} setFilter={handleSetFilter} />
      {cameraSelect.length > 0 ? (
        <StreamCam
          streaming={streaming}
          useRef={ref}
          setStreaming={updateStreaming}
          page={page}
          getCodeInfo={handleGetShowInfoCamera}
          getCodeSetting={handleGetShowSetting}
          set={setStreaming}
          filter={filterStatus}
          setTotal={setTotal}
          onShowRename={handleCloseRename}
          setNameCamera={setNameCamera}
          nameCamera={nameCamera}
        />
      ) : (
        <SearchFail title={t("stream.noCamera")} />
      )}

      {isModalInfo && (
        <div className={cx("modal-detail")}>
          <ModalInfo
            camera={infoCamera}
            onClose={handleClose}
            show={isModalInfo}
            loading={isLoad}
          />
        </div>
      )}

      {isSetting && (
        <div className={cx("modal-detail")}>
          <ModalSetting
            onclose={handleCloseSetting}
            setIsRefresh={setIsRefresh}
            isRefresh={isRefresh}
            camera={infoCamera}
            setIsSetting={setIsSetting}
          />
        </div>
      )}
      {isFullScreen && (
        <div
          style={showTaskbar ? {} : { display: "none" }}
          className={cx("bottom")}
        ></div>
      )}
      {isRename && (
        <div className={cx("modal-detail")}>
          <RenameCamera
            nameCamera={nameCamera}
            setNameCamera={setNameCamera}
            handleClose={handleCloseRename}
            reNameCamera={reNameCamera}
          />
        </div>
      )}
    </div>
  );
};
export default Camera;
